import axios from "axios";
import { Toast } from "vant";

//export const baseUrl =process.env.NODE_ENV == "production" ? process.env.VUE_APP_BASE_URL : "/api";;
export const baseUrl = '/api';//process.env.VUE_APP_BASE_URL'';
export function request(config) {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
  });

  //请求拦截
  instance.interceptors.request.use(
    (config) => {
      // var token = localStorage.getItem("token");
      // if (token) {
      //   config.headers.Authorization = `Bearer ${token}`;
      // }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      return config;
    },
    (err) => {
      return Promise.reject(err); //请求错误处理
    }
  );

  // 响应拦截
  instance.interceptors.response.use(
    (res) => {
      Toast.clear();
      console;
      if (res.data.success == true) {
        return res;
      } else if (res.data.success == false) {
        localStorage.clear();
        return res;
      } else {
        return res;
      }
      // let code = res.data.code //状态码
    },
    (err) => {
      Toast.clear();
      return Promise.reject(err); //请求错误处理
    }
  );

  return instance(config);
}
